import _sfc_main from './PortfolioEvaluationChart.vue2.js';
import normalizeComponent from '../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-widget fds-portfolio-evaluation-chart", class: { "fds-ui-loading": _setup.isChartLoading } }, [_vm._t("root", function() {
    return [_vm._t("navigation", function() {
      return [_c(_setup.HoistComponent, [_setup.showNavigation ? _c(_setup.UiButtonGroup, { staticClass: "fds-portfolio-evaluation-chart__time-span-selector", attrs: { "value": _setup.selectedTimeSpan ?? "", "buttons": _setup.timeSpanButtons }, on: { "input": _setup.changeTimeSpan } }) : _vm._e()], 1)];
    }, null, { showNavigation: _setup.showNavigation, timeSpans: _vm.timeSpans, timeSpanButtons: _setup.timeSpanButtons, selectedTimeSpan: _setup.selectedTimeSpan, changeTimeSpan: _setup.changeTimeSpan, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule }), _vm._t("chart", function() {
      return [_c("div", { staticClass: "fds-portfolio-evaluation-chart__chart-container" }, [_c("div", { ref: "chartContainer", staticClass: "fds-ui-chart fds-ui-chart--line fds-portfolio-evaluation-chart__chart", attrs: { "id": _setup.chartId } })])];
    }, null, { isChartLoading: _setup.isChartLoading, chartId: _setup.chartId, seriesData: _setup.seriesData, getChartConfig: _setup.getChartConfig, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule })];
  }, null, { isChartLoading: _setup.isChartLoading, chartId: _setup.chartId, seriesData: _setup.seriesData, getChartConfig: _setup.getChartConfig, showNavigation: _setup.showNavigation, timeSpans: _vm.timeSpans, selectedTimeSpan: _setup.selectedTimeSpan, changeTimeSpan: _setup.changeTimeSpan, localizationSupport: _setup.localizationSupport, storeModule: _setup.storeModule })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/portfolio-evaluation-chart/PortfolioEvaluationChart.vue";
var PortfolioEvaluationChart = __component__.exports;

export { PortfolioEvaluationChart as default };
